import * as React from "react";
import { Button, StyleProp, StyleSheet, ViewStyle } from "react-native";

import { View } from "../../components/Themed";
import useCreateFamily from "../../hooks/families/useCreateFamily";
import { Family } from "../../types";

export interface FamilyListItemProps {
  style?: StyleProp<ViewStyle>;
  family?: Family;
}

function FamilyListItem({ style }: FamilyListItemProps) {
  const { mutateAsync: createFamily } = useCreateFamily();

  return (
    <View style={style}>
      <Button
        title="Add Family"
        onPress={async () => {
          try {
            await createFamily({ name: "testing" });
          } catch (err) {
            // TODO
          }
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({});

export default FamilyListItem;
